'use client';

import { useEffect, useState } from 'react';

const PROD_HOST_SUFFIXES = ['.vercel.app', 'nextroofq.com'];

export default function DevBadge() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') return;
    const host = window.location.hostname;
    if (PROD_HOST_SUFFIXES.some((s) => host.endsWith(s))) return;
    setShow(true);
  }, []);

  if (!show) return null;

  return (
    <div
      aria-hidden="true"
      className="fixed bottom-4 right-4 z-[9999] flex h-5 w-10 items-center justify-center rounded bg-amber-500 font-mono text-[11px] font-bold text-white opacity-80 shadow-md pointer-events-none select-none"
    >
      DEV
    </div>
  );
}
